import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import DashBoard from '@/api/dashboard/api-dashboard';
import { getCompanyID, getEmployeeID } from '@/helpers/Utils';

export const fetchDashBoardSpecificDayDetails = createAsyncThunk(
  'dashboardSpecificDay/fetchDashBoardSpecificDayDetails',
  async (params, thunkAPI) => {
    try {
      const { day, month, year } = params;
      const response = await DashBoard.GetAllDashBoardDetailsForSpecificDay({
        companyID: getCompanyID(),
        month: month,
        year: year,
        day: day,
        employeeID: getEmployeeID(),
        employeeNo: '',
      });
      return response?.data?.data;
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  dashBoardDetails: {},
  loading: false,
  error: '',
};

const dashboardSpecificDaySlice = createSlice({
  name: 'dashboardSpecificDay',
  initialState,
  reducers: {
    clearDashboardSpecificDay: (state, action) => {
      state.dashBoardDetails = initialState.dashBoardDetails;
      state.loading = initialState.loading;
      state.error = initialState.error;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashBoardSpecificDayDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDashBoardSpecificDayDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.dashBoardDetails = action.payload;
        state.error = '';
      })
      .addCase(fetchDashBoardSpecificDayDetails.rejected, (state, action) => {
        state.loading = false;
        state.dashBoardDetails = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export const { clearDashboardSpecificDay } = dashboardSpecificDaySlice.actions;
export default dashboardSpecificDaySlice.reducer;
